import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export const patchKanbanTicketAsDeleted = async (projectId, ticketId) => {
  const apiPath = `kanban/project/${projectId}/ticket/${ticketId}/update-as-deleted`;

  const body = {};

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
